import { useMutation } from '@tanstack/react-query';

import TaxonomiesService, {
  SyncTaxonomyDefaultDto,
} from '@/services/TaxonomiesService';

export default function useSyncTaxonomyDefault() {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (syncTaxonomyDefaultDto: SyncTaxonomyDefaultDto) =>
      TaxonomiesService.syncTaxonomyDefault(syncTaxonomyDefaultDto),
  });

  return { syncTaxonomyDefault: mutateAsync, isSyncing: isPending };
}
